export default {
  oops: 'Oops...',
  validOrigin: 'Selecteer een geldige vertrekplaats',
  validDestination: 'Selecteer een geldige bestemming',
  validOutboundDate: 'Selecteer een geldige vertrekdatum',
  validReturnDate: 'Selecteer een geldige retourdatum',
  validChildAges: 'Selecteer alstublieft alle kinderen',
  oneChild: 'Slechts 1 kind (0-2 jaar) per volwassene is toegestaan',
}
